import React, { useContext } from 'react'
import { useWeb3React } from '@web3-react/core'

import { ConnectWallet } from 'src/components/ConnectWallet'
import { ManageNew } from 'src/components/Manage/ManageNew'
import { Spinner } from 'src/components/Spinner'
import { ArcContext } from '../../contexts/ArcContext'
import { eqIgnoreCase } from '@arcxmoney/arcx-core'

export function NewPosition() {
  const arcContext = useContext(ArcContext)
  const web3context = useWeb3React()
  if (!web3context.account) {
    return <ConnectWallet />
  }

  const _synths = arcContext.synths.filter(({ synthetic }) => eqIgnoreCase(synthetic, 'STABLEx'))

  const showSpinner =
    _synths.length === 0 || arcContext.prices.length !== arcContext.synths.length || !arcContext.arc

  return <div className="page">{showSpinner ? <Spinner /> : <ManageNew synths={_synths} />}</div>
}
